import React from 'react';
import { Helmet } from 'react-helmet';
import { connect, useSelector } from 'react-redux';
import ProductListPage from './ProductListPage';
function AllProductsPage({ categorySlug, subCategorySlug }) {
    var _a;
    const isLoading = useSelector((state) => state.products.productsLoading);
    const products = useSelector((state) => state.products.products);
    const categories = useSelector((state) => state.products.categories);
    if (isLoading || !products || !categories) {
        return React.createElement(React.Fragment, null);
    }
    const preSelectedCategory = categories.find((c) => c.slug === categorySlug);
    const preSelectedSubCategory = (_a = preSelectedCategory === null || preSelectedCategory === void 0 ? void 0 : preSelectedCategory.children) === null || _a === void 0 ? void 0 : _a.find((c) => c.slug === subCategorySlug);
    let title, path;
    if (!preSelectedCategory) {
        title = 'Alle Produkter';
        path = '';
    }
    else {
        if (!preSelectedSubCategory) {
            title = preSelectedCategory.name;
            path = preSelectedCategory.slug;
        }
        else {
            title = `${preSelectedCategory.name} - ${preSelectedSubCategory.name}`;
            path = `${preSelectedCategory.slug}/${preSelectedSubCategory.slug}`;
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("title", null,
                title,
                " - Morgenlevering"),
            React.createElement("meta", { property: "og:title", content: `${title} - Morgenlevering` }),
            React.createElement("meta", { property: "og:url", content: `https://morgenlevering.no/${path}` })),
        React.createElement(ProductListPage, { heading: "Alle produkter", products: products, filterCategories: categories, preSelectedCategory: preSelectedCategory, preSelectedSubCategory: preSelectedSubCategory })));
}
function mapStateToProps(_state, routeProps) {
    return {
        categorySlug: routeProps.match.params.category,
        subCategorySlug: routeProps.match.params.subcategory,
    };
}
export default connect(mapStateToProps)(AllProductsPage);
